<app-dialog-header title="Move Schedule Quantity" (closeClicked)="cancel()">
</app-dialog-header>

<mat-dialog-content [formGroup]="form" class="quantity-drag-content">
  <div class="summary">
    <div class="line">
      <span class="label">SOR:</span>
      <span class="value">
        {{ data.schedule.sorCode }}
        @if (data.schedule.sorDescription) {
          <span class="muted"> &mdash; {{ data.schedule.sorDescription }}</span>
        }
      </span>
    </div>
    @if (data.schedule.externalScheduleReference) {
      <div class="line">
        <span class="label">Ext Ref:</span>
        <span class="value">{{ data.schedule.externalScheduleReference }}</span>
      </div>
    }
    @if (data.schedule.sorSmv !== null) {
      <div class="line">
        <span class="label">SMV:</span>
        <span class="value">{{ data.schedule.sorSmv }}</span>
      </div>
    }
    <div class="line">
      <span class="label">From:</span>
      <span class="value">
        Visit #{{ data.source.id ?? "(new)" }} ({{ data.source.visitStatus }})
      </span>
    </div>
    <div class="line">
      <span class="label">To:</span>
      <span class="value">
        Visit #{{ data.target.id ?? "(new)" }} ({{ data.target.visitStatus }})
      </span>
    </div>
  </div>

  <mat-form-field appearance="fill" class="quantity-field">
    <mat-label>Quantity to move</mat-label>
    <input
      matInput
      type="number"
      step="0.0001"
      min="0"
      formControlName="quantity"
      data-testid="quantity-input"
    />
    <mat-hint>Source has {{ maxQuantity }} active</mat-hint>
    @if (form.controls.quantity.hasError("required")) {
      <mat-error>Required</mat-error>
    }
    @if (form.controls.quantity.hasError("tooSmall")) {
      <mat-error>Must be greater than 0</mat-error>
    }
    @if (form.controls.quantity.hasError("tooLarge")) {
      <mat-error>Cannot exceed {{ maxQuantity }}</mat-error>
    }
    @if (form.controls.quantity.hasError("invalid")) {
      <mat-error>Must be a number</mat-error>
    }
  </mat-form-field>

  @if (sourceWillBeSplit) {
    <p class="note">
      Source visit will keep the remaining active quantity (split).
    </p>
  }
  @if (data.sourceWillArchive) {
    <p class="note warn">
      Source visit is locked &mdash; the moved quantity will be archived as a
      ghost row on the source.
    </p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="form.invalid"
    (click)="confirm()"
    data-testid="confirm-button"
  >
    Move
  </button>
</mat-dialog-actions>
